import React from 'react';
import { Carousel, CarouselItem } from '../../../Carousel';
import { Box } from '../../../Box';
import {
  Breakpoints,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import { CarouselFragmentProps } from '../types';

const mockItems: CarouselItem[] = [
  { mediaUrl: 'https://picsum.photos/800/400?car=1' },
  { mediaUrl: 'https://www.w3schools.com/html/mov_bbb.mp4' },
  {
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam`,
  },
  {
    mediaUrl: 'https://picsum.photos/800/400?car=4',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam`,
  },
  { title: 'Performance that excites' },
  {
    title: 'Title',
    mediaUrl: 'https://picsum.photos/800/400?car=5',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et`,
  },
  {
    mediaUrl: 'https://picsum.photos/800/400?car=4',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam`,
  },
  {
    title: 'Performance that excites',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam`,
  },
];

export const CarouselFragment = ({
  title = 'Carousel title',
}: CarouselFragmentProps) => {
  return (
    <Box style={{ marginTop: '2rem' }}>
      {title && (
        <Box style={(theme) => ({ padding: theme.size.static450 })}>
          <TextCustom
            appearance={TextAppearance.headline300}
            tag={TextTag.h2}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize24,
                fontWeight: TextWeight.bold,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
              [Breakpoints.b1280]: {
                fontSize: TextSize.TextSize28,
                fontWeight: TextWeight.bold,
                lineHeight: TextLineHeight.TextLineHeight28,
              },
            }}
          >
            {title}
          </TextCustom>
        </Box>
      )}
      <Carousel id='demo-1' ariaLabel='Test Gallery 1' items={mockItems} />
    </Box>
  );
};
